import React from 'react';
import agency from '../assets/reception-desk-outline-icon-graphics-vector-53985679.jpg';
import residence from '../assets/pngtree-house-location-icon-png-image_1701248.jpg';
import restaurent from '../assets/3448609.png';
import transport from '../assets/a5897788c8307780c9291e357c93db15.jpg';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const LandingPageOffers = () => {
  return (
    <nav className="w-full h-auto max-w-7xl flex flex-wrap justify-center items-center mt-10 gap-6 px-4 sm:grid sm:grid-cols-2 sm:gap-8" lang='rtl'>
      {/* Offer 1 */}
      <motion.div
        className="bg-white p-6 rounded-lg flex flex-col sm:flex-row justify-between items-center hover:scale-105 hover:shadow-xl transition-transform"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, type: 'spring', stiffness: 50 }}
      >
        <Link to="./OffersPage" className="flex flex-col sm:flex-row justify-center items-center">
          <img src={agency} alt="agency" className="w-16 h-auto sm:w-24" />
          <div className="flex flex-col justify-center items-center sm:items-start mt-4 p-4 sm:mt-0 sm:ml-6">
            <span className="text-3xl sm:text-base font-bold text-darkGreen mb-3">وكالات سياحية</span>
            <p className="text-sm sm:text-lg text-cright sm:text-right">
              اكتشف أفضل العروض السياحية لدينا! انطلق معنا في رحلة فريدة تناسب جميع اهتماماتك وتلبي كل احتياجاتك.
            </p>
          </div>
        </Link>
      </motion.div>

      {/* Offer 2 */}
      <motion.div
        className="bg-white p-6 rounded-lg flex flex-col sm:flex-row justify-between items-center hover:scale-105 hover:shadow-xl transition-transform"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, type: 'spring', stiffness: 50 }}
      >
        <Link to="./ResidencePage" className="flex flex-col sm:flex-row justify-center items-center">
          <img src={residence} alt="residence" className="w-16 h-auto sm:w-24" />
          <div className="flex flex-col justify-center items-center sm:items-start mt-4 p-4 sm:mt-0 sm:ml-6">
            <span className="text-3xl sm:text-base font-bold text-darkGreen mb-3">الاقامات</span>
            <p className="text-sm sm:text-lg text-right sm:text-right">
              استمتع بتجربة الإقامة المثالية مع وكالتنا! نوفر لك أفضل خيارات السكن لتلبي كافة تطلعاتك.
            </p>
          </div>
        </Link>
      </motion.div>

      {/* Offer 3 */}
      <motion.div
        className="bg-white p-6 rounded-lg flex flex-col sm:flex-row justify-between items-center hover:scale-105 hover:shadow-xl transition-transform"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, type: 'spring', stiffness: 50 }}
      
      >
        <Link to="./Restaurant" className="flex flex-col sm:flex-row justify-center items-center">
          <img src={restaurent} alt="restaurant" className="w-16 h-auto sm:w-24" />
          <div className="flex flex-col justify-center items-center sm:items-start mt-4 p-4 sm:mt-0 sm:ml-6">
            <span className="text-3xl sm:text-base font-bold text-darkGreen mb-3">المطاعم</span>
            <p className="text-sm sm:text-lg text-right sm:text-right">
              استمتع بأشهى المأكولات مع وكالتنا! نقدم لك دليلًا لأفضل المطاعم.
            </p>
          </div>
        </Link>
      </motion.div>

      {/* Offer 4 */}
      <motion.div
        className="bg-white p-6 rounded-lg flex flex-col sm:flex-row justify-between items-center hover:scale-105 hover:shadow-xl transition-transform"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, type: 'spring', stiffness: 50 }}
      >
        <Link to="./TransportOffersPage" className="flex flex-col sm:flex-row justify-center items-center">
          <img src={transport} alt="transport" className="w-16 h-auto sm:w-24" />
          <div className="flex flex-col justify-center items-center sm:items-start mt-4 p-4 sm:mt-0 sm:ml-6">
            <span className="text-3xl sm:text-base font-bold text-darkGreen mb-3">النقل</span>
            <p className="text-sm sm:text-lg text-right sm:text-right">
              رحلاتك تبدأ معنا! نوفر لك خدمات نقل مريحة وآمنة لتجربة سفر لا تُنسى.
            </p>
          </div>
        </Link>
      </motion.div>
    </nav>
  );
};

export default LandingPageOffers;
